/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScheduleType } from '@gh/builder-shared-data';
import { AbstractFinderGridDefinition, dictionaryValueFormatter } from '@gh/common-internal-shared';

import { EnumDictionary, getDialogInitData } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';

import { ColDef } from 'ag-grid-community';

import { ScheduleTemplateListItem } from '../../resources/schedule-template-finder.model';

@Injectable()
export class ScheduleTemplateFinderDialogGridDefinition extends AbstractFinderGridDefinition {

  scheduleType: EnumDictionary<ScheduleType>;

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              private translationService: TranslationService) {
    super();

    const { scheduleType } = getDialogInitData(this.dialogData);
    this.scheduleType = scheduleType;
  }

  getId = ({ id }: ScheduleTemplateListItem) => id;

  buildColumnDefs(): ColDef[] {
    return [
      {
        field: 'name',
        headerName: this.translationService.get('lbl_name'),
      },
      {
        field: 'type',
        headerName: this.translationService.get('lbl_type'),
        valueFormatter: dictionaryValueFormatter(this.scheduleType),
      },
    ];
  }
}
